<div class="row">
	<div class="col-xs-12 col-md-12">
		<div [attr.id]="graphId" class="pedigree-graph"></div>
	</div>
</div>
